import React from 'react';
import { Box, Text, Grid } from '@chakra-ui/react';

const toCompact = (value) => {
    if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
    if (value >= 1_000) return `${(value / 1_000).toFixed(1)}K`;
    return String(value);
};

const formatValue = (value, format) => {
    if (format === 'percent') return `${value}%`;
    if (format === 'currency') return `$${toCompact(value)}`;
    if (format === 'numberCompact') return toCompact(value);
    return value?.toLocaleString?.() ?? value;
};

export const StatsGrid = ({ items }) => {
    if (!items || items.length === 0) return null;

    return (
        <Grid templateColumns={`repeat(${Math.min(items.length, 3)}, 1fr)`} gap={2} mt={3}>
            {items.map((item, idx) => (
                <Box
                    key={idx}
                    p={2.5}
                    bg="gray.50"
                    borderRadius="lg"
                    borderWidth="1px"
                    borderColor="gray.200"
                >
                    <Text fontSize="2xs" color="gray.500" fontWeight="semibold" textTransform="uppercase" letterSpacing="wide" mb={1}>
                        {item.label}
                    </Text>
                    <Text fontSize="lg" fontWeight="bold" color="gray.900" lineHeight={1}>
                        {formatValue(item.value, item.format)}
                    </Text>
                </Box>
            ))}
        </Grid>
    );
};
